import Axios from 'axios';
import react, { useEffect, useReducer, useRef } from 'react';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';

export type SelectType = {
	country?: string;
	department?: string; // NOTE: 不同地区的 tel 可能重复
	job?: string;
	desc?: string;
	welfare?: string;
	workType?: string;
	operation?: string;
	id: number;
};

/**
 * 获取select信息
 * @returns
 */
export default function useJobSelect() {
	const [, forceUpdate] = useReducer((c) => c + 1, 0);
	const local = useSelector((state: ConnectState) => state.app.local);
	const ref = useRef<SelectType[]>([]);

	useEffect(() => {
		Axios.get(`https://web-data.zmlearn.com/config/5JX8dsopNXEWrLLeqLHrMC/data.json?time=${new Date().getTime()}`, { timeout: 4000 }).then(
			(res) => {
				ref.current = res.data as SelectType[];
				forceUpdate();
			}
		);
	}, [local]);
	return ref.current;
}
